import { apiGet } from '@/api/main/client'
import { useQuery } from '@tanstack/react-query'
import { withdrawsAPITrader } from '../api'
import { WithdrawFile } from '../model'

export const useReceiptDetail = (withdrawId: string | null, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['withdraws', 'receipts', withdrawId],
    queryFn: () => apiGet<WithdrawFile[]>(withdrawsAPITrader.getReceipts(withdrawId!)),
    enabled: enabled && !!withdrawId,
    staleTime: 0, // Всегда получать свежие данные при открытии модалки
  })
}
